import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss', '../../assets/partials/blog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BlogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
